import React, { Fragment } from 'react';

import { ajax, ProfileLevels, myDeepCopy, setEmptyStrings, loadUsersList } from '../components/globals';
import { Languages } from '../components/languages';

import {
    InputSection
} from '../components/utilities';
import { PageTitle, UserCard, UIMessageBox, UIButton, UIPopup} from '../components/guiElements';
import {
    emptyValidation, 
    validate
} from '../components/validate';
import UsersList from '../components/usersList';

// flex align
//https://stackoverflow.com/questions/18744164/flex-box-align-last-row-to-grid

export default class UserProfile extends React.Component {
    constructor(props) {
        super(props);
        this.changeValue = this.changeValue.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
        this.onActionClick = this.onActionClick.bind(this);

        this.saveClick = this.saveClick.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.addUser = this.addUser.bind(this);
        this.toggleUsersListHandler = this.toggleUsersListHandler.bind(this);
        this.createUser = this.createUser.bind(this);
        this.cancelCreateUser = this.cancelCreateUser.bind(this);
        this.le = Languages.UserProfile[Languages.selectedLanguage];

        this.configs = {
            card: { title: this.le.card.title, },
            sections: [
                {
                    id: 'registration',
                    title: this.le.registration.title,
                    mandatoryMessage: this.le.registration.mandatoryMessage,
                    columns: [{
                        id: 'C1',
                        rowsize: 20,
                        itemunit: 10,
                        items: [
                            { id: 'name', size: 10, text: this.le.registration.name, type: 'text', mandatory: true },
                            { id: 'surname', size: 10, text: this.le.registration.surname, type: 'text', mandatory: true  },
                            { id: 'password', size: 10, text: this.le.registration.password, type: 'password', mandatory: true  },
                            { id: 'confirm', size: 10, text: this.le.registration.confirm, type: 'password', mandatory: true  },

                            { id: 'phone', size: 10, text: this.le.registration.phone, type: 'tel', mandatory: true },
                            { id: 'email', size: 10, text: this.le.registration.email, type: 'email', mandatory: true, disabled: true  },
                        ],
                        buttons: [{ type: 'confirm wide', text: this.le.buttons[0], click: this.saveClick }]
                    }]
                },
                {
                    id: 'invoicing',
                    extraClass: 'mango',
                    title: this.le.invoicing.title,
                    invoiceMessage: this.le.invoicing.invoiceMessage,
                    columns: [
                        {
                            id: 'C1',
                            rowsize: 20,
                            itemunit: 10,
                            items: [
                                { id: 'name', size: 10, text: this.le.invoicing.name, type: 'text', mandatory: false,disabled: true  },
                                { id: 'surname', size: 10, text: this.le.invoicing.surname, type: 'text', mandatory: false,disabled: true  },
                                { id: 'businessName', size: 20, text: this.le.invoicing.businessName, type: 'text', mandatory: false,disabled: true  },
                                { id: 'address', size: 20, text: this.le.invoicing.address, type: 'text', mandatory: false,disabled: true  },
                                { id: 'city', size: 20, text: this.le.invoicing.city, type: 'text', mandatory: false,disabled: true  },
                                { id: 'province', size: 10, text: this.le.invoicing.province, type: 'text', mandatory: false, MaxLength: 2,disabled: true  },
                                { id: 'zipCode', size: 10, text: this.le.invoicing.zipCode, type: 'number', mandatory: false,disabled: true  },
                                { id: 'fiscalCode', size: 20, text: this.le.invoicing.fiscalCode, type: 'text', mandatory: false,disabled: true  },

                                { id: 'phone', size: 20, text: this.le.invoicing.phone, type: 'tel', mandatory: false,disabled: true  },
                                { id: 'certEmail', size: 20, text: this.le.invoicing.certEmail, type: 'email', mandatory: false,disabled: true  },
                                //{ id: 'confirm', size: 20, text: this.le.invoicing.confirm, type: 'email', mandatory: false,disabled: true  },
                                { id: 'vatNumber', size: 20, text: this.le.invoicing.vatNumber, type: 'number', mandatory: false,disabled: true  },
                                { id: 'uniqueCode', size: 20, text: this.le.invoicing.uniqueCode, type: 'text', mandatory: false,disabled: true  },
                                { id: 'adminEmail', size: 20, text: this.le.invoicing.adminEmail, type: 'email', mandatory: false,disabled: true  }                               
                            ],
                        }
                    ],
                }
            ]
        };
        
        this.uc = JSON.parse(sessionStorage.getItem("userContext"));

        if (this.uc.userRole === ProfileLevels[0]) {
            this.configs.sections[0].columns[0].items.push({ id: 'chkAdmin', size: 5, text: this.le.registration.chkAdmin, type: 'radio', group: 'level' });
            this.configs.sections[0].columns[0].items.push({ id: 'chkUser', size: 5, text: this.le.registration.chkUser, type: 'radio', group: 'level' });
            this.configs.sections[0].columns[0].items.push({ id: 'chkReadonly', size: 3, text: this.le.registration.chkReadonly, type: 'radio', group: 'level' });
            this.configs.sections[0].columns[0].items.push({ id: 'chkUserPro', size: 3, text: this.le.registration.chkUserPro, type: 'radio', group: 'level' });
        }


        this.headers = [];

        

        this.headers.push({
            generic: { manage: 0, name: 'name', width: 10, change: this.onFieldChange, click: null },
            caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.usersList.captions[0] },
            element: { type: 'input', fieldType: 'text', colClass: null, itemClass: null, options: [] }
        });
        this.headers.push({
            generic: { manage: 0, name: 'surname', width: 7, change: this.onFieldChange, click: null },
            caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.usersList.captions[1] },
            element: { type: 'input', fieldType: 'text', colClass: null, itemClass: null, options: null }
        });
        this.headers.push({
            generic: { manage: 0, name: 'password', width: 7, change: this.onFieldChange, click: null },
            caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.usersList.captions[2] },
            element: { type: 'input', fieldType: 'password', colClass: null, itemClass: null, options: null, mandatory: true }
        });
        this.headers.push({
            generic: { manage: 0, name: 'confirmPwd', width: 7, change: this.onFieldChange, click: null },
            caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.usersList.captions[3] },
            element: { type: 'input', fieldType: 'password', colClass: null, itemClass: null, options: null, mandatory: true }
        });
        this.headers.push({
            generic: { manage: 0, name: 'phone', width: 5, change: this.onFieldChange, click: null },
            caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.usersList.captions[4] },
            element: { type: 'input', fieldType: 'text', colClass: null, itemClass: 'upper', options: null }
        });
        this.headers.push({
            generic: { manage: 0, name: 'email', width: 13, change: this.onFieldChange, click: null },
            caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.usersList.captions[5] },
            element: { type: 'input', fieldType: 'email', colClass: null, itemClass: null, options: null }
        });
        this.headers.push({
            generic: { manage: 0, name: 'profileType', width: 13, change: this.onFieldChange, click: null },
            caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.usersList.captions[6] },
            element: { 
                    type: 'select',
                    colClass: null,
                    itemClass: null,
                    options: [
                    {
                        text: 'Admin',
                        value: 'admin'
                    },
                    {
                        text: 'Readonly',
                        value: 'readonly'
                    },
                    {
                        text: 'User',
                        value: 'user'
                    },
                    {
                        text: 'Utente Pro',
                        value: 'userPro'
                    },
                ]
            }
        });
        this.headers.push({
            generic: { manage: 1, default: null, name: 'action', width: 11, change: null, click: this.onActionClick },
            caption: { type: 'label', colClass: null, itemClass: 'bold center', value: this.le.usersList.captions[7] },
            element: { type: 'button',
            colClass: 'center',
            itemClass: 'action',
            btnSaveText: this.le.usersList.popup.saveButton,
            btnDeleteText: this.le.usersList.popup.deleteButton,
            options: null
        }
        });


        this.listKey = 0;

        this.originalData = {
            card: {
                image: this.uc.image || '../../images/user3x-d.png',
                name: this.uc.firstName + " " + this.uc.lastName,
                email: this.uc.username,
                level: this.uc.userRole.toUpperCase(),
                logout: this.le.card.logout,
                edit: this.le.card.edit,
                addUser: this.le.addUser,
                usersList: this.le.usersList.buttonText,
                isSuperAdmin: this.uc.isSuperAdmin
            },
            registration: {
                name: this.uc.firstName,
                surname: this.uc.lastName,
                password: 'xxxxxxxxxxxxxxxxxxxx',
                confirm: 'xxxxxxxxxxxxxxxxxxxx',
                phone: this.uc.phone || "",
                email: this.uc.username,
                chkAdmin: this.uc.userRole == ProfileLevels[0],
                chkUser: this.uc.userRole == ProfileLevels[1],
                chkReadonly: this.uc.userRole == ProfileLevels[2],
                chkUserPro: this.uc.userRole == ProfileLevels[3]

            },
            invoicing: {
                name: '',
                surname: '',
                businessName: '',
                address: '',
                city: '',
                province: '',
                zipCode: '',
                fiscalCode: '',
                phone: '',
                certEmail: '',
               // confirm: '',
                vatNumber: '',
                uniqueCode: '',
                adminEmail: ''
            },
            usersListPasswordFields: {
                password: 'xxxxxxxxxxxxxxxxxxxx',
                confirm: 'xxxxxxxxxxxxxxxxxxxx',
            }
        };
        this.backups = {};
        this.empties = {
            registration: {
                name: '',
                surname: '',
                password: '',
                confirm: '',
                phone: '',
                email: '',
                chkAdmin: false,
                chkUser: true,
                chkReadonly: false,
                chkuUserPro: false
            }
        };

      
        this.navigationParams = "";
        if (this.props.location.state && this.props.location.state.params)
            this.navigationParams = this.props.location.state.params;
        
        this.state = {
            data: this.originalData,
            pageStyle: this.uc.userRole === ProfileLevels[0] ? 0 : 1,
            modalType: 0,
            userModalType: 0,
            modalMsg: "",
            msgNumber: 0,
            isSuperAdmin: this.uc.isSuperAdmin,
            showUsersList: false,
            usersList: []
        };
        
    }

    //#region Events

    componentDidMount() {
        try {
            this.props.loaderShow();
            ajax(this, { method: 'get', url: '/api/userprofile', headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
                response => {
                    Object.assign(this.originalData.invoicing, response.data.result.userBilling);
                    this.originalData.invoicing.confirm = this.originalData.invoicing.certEmail;
                    this.originalData = setEmptyStrings(this.originalData);
                    this.setState({ data: this.originalData });
                    if (this.navigationParams=="NEW_USER") {

                        this.addUser();
                        this.navigationParams = "";

                    }
                    this.props.loaderHide();
                },
                error => {
                    this.props.loaderHide();
                    this.setState({ modalType: 1, modalMsg: error.message });
                }
            );
            loadUsersList(this.uc.jwtToken,  usersList => {
                const transformedUsersList = usersList.map((user) => {
                    return {
                        user: {
                            ...user,
                            password: 'xxxxxxxxxxxxxxxxxxxx',
                            confirmPwd: 'xxxxxxxxxxxxxxxxxxxx',
                            originalPassword: 'xxxxxxxxxxxxxxxxxxxx',
                            originalConfirmPwd: 'xxxxxxxxxxxxxxxxxxxx',
                        },
                        originaUserData: {
                            ...user,
                            password: 'xxxxxxxxxxxxxxxxxxxx',
                            confirmPwd: 'xxxxxxxxxxxxxxxxxxxx',
                            originalPassword: 'xxxxxxxxxxxxxxxxxxxx',
                            originalConfirmPwd: 'xxxxxxxxxxxxxxxxxxxx',
                        }
                    }
                });
                this.setState({
                    usersList: transformedUsersList
                })
            },
            ko => { },
            this)
        }
        catch (e) {
            this.props.loaderHide();
        }

    }

    onFieldChange(ev, name, value, userId) {
        this.setState((prevState) => {
            const updatedUsersList = prevState.usersList.map((user) => {
              if (user.user.id === userId) {
                
                return { 
                    user: {
                        ...prevState.user,
                        ...user.user,
                        [name]: value,
                    },
                    originaUserData: {
                        ...user.originaUserData,
                    }
                   
                };
              }
              return user;
            });

            return { usersList: updatedUsersList };
          });
    }

    modifyUserList(userId) {
        let postData = {};
        const user = this.state.usersList.find(user => user.user.id === userId);
        const {
            user: userData,
            originaUserData,
        } = user;
        const {
            password: userPassword,
            confirmPwd: userConfirmPassword,
            originalPassword: userOriginalPassword,
            email: userEmail,
            name: userName,
            surname: userSurname,
            phone: userPhone,
            profileType: userProfileType
        } = userData;
        
        if(JSON.stringify(userData) !== JSON.stringify(originaUserData)) {
            let pwd = userPassword;
            if (pwd !== userConfirmPassword) {
                this.setState({ userModalType: 1, modalMsg: '', msgNumber: 1 });
                return;
            }
            if (pwd === userOriginalPassword) {
                pwd = "";
            } else if (pwd.length < 6 || !pwd.match(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/g)) {
                this.setState({ userModalType: 1, modalMsg: '', msgNumber: 2 });
                return;
            }

            let isAdmin = userProfileType === ProfileLevels[0];;
            let userSignUp = {};
            userSignUp.Id = userId;
            userSignUp.Email = userEmail;
            userSignUp.Password = pwd;
            userSignUp.ConfirmPwd = pwd;
            userSignUp.IsAdmin = isAdmin;
            userSignUp.Name = userName;
            userSignUp.Surname = userSurname;
            userSignUp.Phone = userPhone;
            userSignUp.ProfileType = userProfileType;
            postData.userSignUp = userSignUp;
        }


        if (!!postData.userSignUp) {
            ajax(this, { method: 'post', url: `/api/userprofile/post-profile`, headers: { Authorization: 'Bearer ' + this.uc.jwtToken }, data: postData },
            response => {
                this.setState({
                    userModalType: 2, modalMsg: '', msgNumber: 0
                });
            },
            error => {
                this.setState({ userModalType: 1, modalMsg: error.message });
            }
         );
        }
    }

    deleteUserList(userId) {
        ajax(this, { method: 'post', url: 'api/userprofile/user-creds-organization-delete/' + userId, headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
            response => {
                const users = this.state.usersList.filter(user => user.user.id !== userId);
                this.setState({
                        usersList: users,
                        userModalType: 2,
                        modalMsg: '',
                        msgNumber: 0
                    });
            },
            error => {
                this.setState({ userModalType: 1, modalMsg: error.message });
            }
        );
    }

    onActionClick(actionType, userId) {

        if(actionType === 'modify') {
        

            this.modifyUserList(userId)
        } else {
            this.deleteUserList(userId)
        }
    }

    changeValue(ev, who, val) {
        let newData = JSON.parse(JSON.stringify(this.state.data));
        const sections = this.configs.sections, first = sections[who[0]].id, second = sections[who[0]].columns[who[1]].items[who[2]].id;
        if (sections[who[0]].columns[who[1]].items[who[2]].type === 'radio') {
            let group = sections[who[0]].columns[who[1]].items[who[2]].group;
            sections[who[0]].columns.forEach(function (col) {
                col.items.forEach(function (item) {
                    if (item.type === 'radio' && item.group === group) newData[first][item.id] = false;
                });
            });
        }
        newData[first][second] = val;
        this.setState({ data: newData });
    }

    saveClick(ev) {

        let validationData = [];
        this.configs.sections.forEach(sec => {
            if (sec.id == "invoicing" && this.state.pageStyle != 0)
                return;
            let src = this.state.data[sec.id];
            sec.columns.forEach(col => {
                col.items.forEach(itm => {
                    if (itm.mandatory)
                        validationData.push({
                            fieldObject: itm,
                            fieldName: itm.id,
                            fieldValue: src[itm.id],
                            fieldError: 'error',
                            validate: emptyValidation
                        });
                }, this);
            }, this);
        }, this);

        if (!validate(validationData)) {
            this.props.popupErrorMessage(this.le.messages[0].messages[3]);
            return;
        }


        let postData = {};

        if (JSON.stringify(this.state.data.invoicing) !== JSON.stringify(this.originalData.invoicing)) {
            if (this.state.data.invoicing.certEmail !== this.state.data.invoicing.confirm) {
                this.setState({ modalType: 1, modalMsg: '', msgNumber: 0 });
                return;
            }
            postData.userBilling = this.state.data.invoicing;
        }

        if (JSON.stringify(this.state.data.registration) !== JSON.stringify(this.originalData.registration)) {
            let pwd = this.state.data.registration.password;
            if (pwd !== this.state.data.registration.confirm) {
                this.setState({ modalType: 1, modalMsg: '', msgNumber: 1 });
                return;
            }
            if (pwd === this.originalData.registration.password) {
                pwd = "";
            } else if (pwd.length < 6 || !pwd.match(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/g)) {
                this.setState({ modalType: 1, modalMsg: '', msgNumber: 2 });
                return;
            }


            let isAdmin = !!this.state.data.registration.chkAdmin;
            let userSignUp = {};
            userSignUp.Email = this.state.data.registration.email;
            userSignUp.Password = pwd;
            userSignUp.ConfirmPwd = pwd;
            userSignUp.IsAdmin = isAdmin;
            userSignUp.Name = this.state.data.registration.name;
            userSignUp.Surname = this.state.data.registration.surname;
            userSignUp.Phone = this.state.data.registration.phone;

            this.addUserProfileType(userSignUp);
            
            postData.userSignUp = userSignUp;
            console.log(postData, "postData")
        }

        if (!!postData.userSignUp || !!postData.userBilling) {
            ajax(this, { method: 'post', url: '/api/userprofile/post-profile', headers: { Authorization: 'Bearer ' + this.uc.jwtToken }, data: postData },
                response => {
                    if (postData.userSignUp && this.uc.username == postData.userSignUp.Email) {
                        if (!!postData.userBilling) {
                            this.originalData.invoicing = myDeepCopy(this.state.data.invoicing);
                            this.uc.invoicing = true;
                            sessionStorage.setItem("userContext", JSON.stringify(this.uc));
                            this.props.setInvoicing(true);
                        }
                        if (!!postData.userSignUp) {
                            this.originalData.registration = myDeepCopy(this.state.data.registration);
                            this.uc.firstName = postData.userSignUp.Name;
                            this.uc.lastName = postData.userSignUp.Surname;
                            this.uc.phone = postData.userSignUp.Phone;
                            this.uc.username = postData.userSignUp.Email;
                            this.uc.userRole = postData.userSignUp.ProfileType;
                            sessionStorage.setItem("userContext", JSON.stringify(this.uc));
                        }
                    }
                    this.setState({ modalType: 2, modalMsg: '', msgNumber: 0 });
                },
                error => {
                    this.setState({ modalType: 1, modalMsg: error.message });
                }
            );
        }
    }

    closeModal(ev) {
        this.setState({ modalType: 0, modalMsg: "" });
    }

    addUser(ev) {
        let newData = JSON.parse(JSON.stringify(this.state.data));
        this.backups.registration = Object.assign({}, newData.registration);
        newData.registration = Object.assign({}, this.empties.registration);

        this.configs.sections[0].columns[0].items[5].disabled = false;

        this.setState({ data: newData, pageStyle: 1 });
    }

    toggleUsersListHandler() {
        this.setState((prevState) => {
            return {
                showUsersList: !prevState.showUsersList
            }
        })
    }


    addUserProfileType (userSignUp) {
        let isAdmin = !!this.state.data.registration.chkAdmin;
        let isUser = !!this.state.data.registration.chkUser;
        let isReadonly = !!this.state.data.registration.chkReadonly;
        let isUserPro = !!this.state.data.registration.chkUserPro;

        if(isAdmin) {
            userSignUp.ProfileType = ProfileLevels[0];
        } else if(isUser){ 
            userSignUp.ProfileType =  ProfileLevels[1]
        } else if(isReadonly) {
            userSignUp.ProfileType = ProfileLevels[2]
        } else if(isUserPro) {
            userSignUp.ProfileType = ProfileLevels[3]
        }

        return userSignUp;
    }

    createUser() {
        let userSignUp = {};
        let isAdmin = !!this.state.data.registration.chkAdmin;
        userSignUp.email = this.state.data.registration.email;
        userSignUp.password = this.state.data.registration.password;
        userSignUp.confirmPwd = this.state.data.registration.confirm;
        userSignUp.isAdmin = isAdmin;
        userSignUp.name = this.state.data.registration.name;
        userSignUp.surname = this.state.data.registration.surname;
        userSignUp.phone = this.state.data.registration.phone;
        
        this.addUserProfileType(userSignUp);
    
        ajax(this, { method: 'post', url: '/api/user', headers: { Authorization: 'Bearer ' + this.uc.jwtToken }, data: userSignUp },
            response => {
                let newData = JSON.parse(JSON.stringify(this.state.data));
                newData.registration = Object.assign({}, this.backups.registration);
                this.setState({ data: newData, pageStyle: 0, modalType: 2, modalMsg: '', msgNumber: 0 });
            },
            error => {
                this.setState({ modalType: 1, modalMsg: error.message });
            }
        );
    }

    cancelCreateUser() {
        let newData = JSON.parse(JSON.stringify(this.state.data));
        newData.registration = Object.assign({}, this.backups.registration);
        this.setState({ data: newData, pageStyle: 0, modalType: 0});
    }

    //#endregion Events

    render() {
        const card = Object.assign({}, this.configs.card, this.state.data.card);
        const sectionsData = myDeepCopy(this.configs.sections);
        if (this.state.pageStyle > 0) sectionsData.splice(1, 1);
        sectionsData.forEach(sec => {
            sec.columns.forEach(col => {
                col.items.forEach(itm => {
                    itm.value = this.state.data[sec.id][itm.id];
                }, this);
            }, this);
        }, this);  // apply values
        const sections = sectionsData.map((el, idx) => (<InputSection key={'sec-' + idx} section={idx} data={el} onChange={this.changeValue} />));

        let modal = null;
        let modalUser = null;
        if (this.state.modalType > 0) {
            const msg = this.le.messages[this.state.modalType - 1];
            modal = <UIMessageBox type="info" title={msg.captions} message={[this.state.modalMsg || msg.messages[this.state.msgNumber]]}>
                <UIButton text="Ok" onClick={(ev) => (this.setState({modalType: 0}))} />
            </UIMessageBox>;
                }


        if (this.state.userModalType > 0) {
            const msg = this.le.messages[this.state.userModalType - 1];
            modalUser = <UIMessageBox type="info" title={msg.captions} message={[this.state.modalMsg || msg.messages[this.state.msgNumber]]}>
                <UIButton text="Ok" onClick={(ev) => (this.setState({userModalType: 0}))} />
            </UIMessageBox>;
        }

                return (
            <div className="page-userprofile">
                <PageTitle icon="../images/user3x-d.png" title={Languages.getSection('Main').menuLabels.profile}/>
                <div className="page-content">
                    <UserCard data={card} handlers={{
                         onEdit: null,
                         onAddUser: this.uc.userRole == 'admin' ? this.addUser : null,
                         onShowUsersList: this.toggleUsersListHandler
                        }
                    }
                    logoutClick={this.props.logoutClick}/>
                    <div className="user-profile-inputs">
                        {sections}
                    </div>
                </div>
                {modal}

                { this.state.showUsersList && <UIPopup
                  className="users-lists-popup"
                  title={this.le.usersList.popup.title}
                  buttons={[
                    <UIButton key="btn-1" className="" text={this.le.usersList.popup.cancelButton} onClick={this.toggleUsersListHandler} />,
                ]}>
                    <div>
                        <UsersList 
                            headers={this.headers}
                            entries={this.state.usersList}/>
                            
                    </div>
                </UIPopup>}

                {modalUser}
            </div>
        );
    }
}

